import { render, staticRenderFns } from "./MyIntroduce.vue?vue&type=template&id=c79a65ee&scoped=true"
import script from "./MyIntroduce.vue?vue&type=script&lang=js"
export * from "./MyIntroduce.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce.vue?vue&type=style&index=0&id=c79a65ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a65ee",
  null
  
)

export default component.exports